import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle, Clock, Lock } from 'lucide-react';

const MAP = {
  compliant: { cls: 'bg-[hsl(var(--success))] text-white', icon: CheckCircle2, label: 'Compliant' },
  valid: { cls: 'bg-[hsl(var(--success))] text-white', icon: CheckCircle2, label: 'Valid' },
  approved: { cls: 'bg-[hsl(var(--success))] text-white', icon: CheckCircle2, label: 'Approved' },
  active: { cls: 'bg-[hsl(var(--success))] text-white', icon: CheckCircle2, label: 'Active' },
  warning: { cls: 'bg-[hsl(var(--warning))] text-[hsl(var(--warning-foreground))]', icon: AlertTriangle, label: 'Warning' },
  expiring: { cls: 'bg-[hsl(var(--warning))] text-[hsl(var(--warning-foreground))]', icon: AlertTriangle, label: 'Expiring' },
  pending: { cls: 'bg-white border border-[hsl(var(--border))] text-foreground', icon: Clock, label: 'Pending' },
  pending_review: { cls: 'bg-[hsl(var(--info))] text-white', icon: Clock, label: 'Pending Review' },
  pending_onboarding: { cls: 'bg-white border border-[hsl(var(--border))] text-foreground', icon: Clock, label: 'Onboarding' },
  pending_reactivation: { cls: 'bg-[hsl(var(--warning))] text-[hsl(var(--warning-foreground))]', icon: Clock, label: 'Pending Reactivation' },
  incomplete: { cls: 'bg-white border border-[hsl(var(--border))] text-muted-foreground', icon: Clock, label: 'Incomplete' },
  expired: { cls: 'bg-[hsl(var(--danger))] text-white', icon: XCircle, label: 'Expired' },
  non_compliant: { cls: 'bg-[hsl(var(--danger))] text-white', icon: XCircle, label: 'Non-Compliant' },
  rejected: { cls: 'bg-[hsl(var(--danger))] text-white', icon: XCircle, label: 'Rejected' },
  terminated: { cls: 'bg-slate-500 text-white', icon: XCircle, label: 'Terminated' },
  blocked: { cls: 'bg-[hsl(var(--danger))] text-white', icon: Lock, label: 'Blocked' },
  out_of_service: { cls: 'bg-[hsl(var(--danger))] text-white', icon: XCircle, label: 'Out of Service' },
};

export function StatusBadge({ status, label, className = '', 'data-testid': testId }) {
  const cfg = MAP[status] || { cls: 'bg-muted text-foreground', icon: Clock, label: status };
  const Icon = cfg.icon;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.cls} ${className}`}>
      <Icon className="h-3 w-3" />
      {label || cfg.label}
    </span>
  );
}
